import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Box, List, ListItem, ListItemText, TextField, Typography } from "@mui/material";

const PAGE_SIZE = 100;

const NewsletterHistoryRecipientsList = ({ recipients }) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);

  const filtered = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) {
      return recipients || [];
    }
    return (recipients || []).filter((email) => email.toLowerCase().includes(query));
  }, [recipients, search]);

  const visible = filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {filtered.length} destinatari
      </Typography>
      <TextField
        fullWidth
        size="small"
        label="Cerca destinatario"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(0);
        }}
        sx={{ mb: 2 }}
      />
      <List dense sx={{ maxHeight: 420, overflow: "auto", border: "1px solid #e2e8f0", borderRadius: 1 }}>
        {visible.length === 0 ? (
          <ListItem>
            <ListItemText primary="Nessun destinatario trovato" />
          </ListItem>
        ) : (
          visible.map((email) => (
            <ListItem key={email} divider>
              <ListItemText primary={email} />
            </ListItem>
          ))
        )}
      </List>
      {totalPages > 1 ? (
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
          <Typography variant="caption" color="text.secondary">
            Pagina {page + 1} di {totalPages}
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography
              component="button"
              variant="caption"
              sx={{ cursor: page > 0 ? "pointer" : "not-allowed", border: "none", bgcolor: "transparent" }}
              onClick={() => page > 0 && setPage((p) => p - 1)}
            >
              Precedente
            </Typography>
            <Typography
              component="button"
              variant="caption"
              sx={{
                cursor: page < totalPages - 1 ? "pointer" : "not-allowed",
                border: "none",
                bgcolor: "transparent",
              }}
              onClick={() => page < totalPages - 1 && setPage((p) => p + 1)}
            >
              Successiva
            </Typography>
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};

NewsletterHistoryRecipientsList.propTypes = {
  recipients: PropTypes.arrayOf(PropTypes.string),
};

export default NewsletterHistoryRecipientsList;
